import { render, staticRenderFns } from "./SaveDiscardMenu.vue?vue&type=template&id=6bb72fcd&scoped=true&"
import script from "./SaveDiscardMenu.vue?vue&type=script&lang=js&"
export * from "./SaveDiscardMenu.vue?vue&type=script&lang=js&"
import style0 from "./SaveDiscardMenu.vue?vue&type=style&index=0&id=6bb72fcd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb72fcd",
  null
  
)

export default component.exports